var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackDelete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 2C10.0265 2 9.59371 2.2675 9.38197 2.69098L8.47746 4.5H4.25C3.55964 4.5 3 5.05964 3 5.75C3 6.44036 3.55964 7 4.25 7L4.25 19.5C4.25 20.8807 5.36929 22 6.75 22H16.75C18.1307 22 19.25 20.8807 19.25 19.5V7C19.9404 7 20.5 6.44036 20.5 5.75C20.5 5.05964 19.9404 4.5 19.25 4.5H15.0225L14.118 2.69098C13.9063 2.2675 13.4735 2 13 2H10.5ZM8 9.5C8 8.80964 8.55964 8.25 9.25 8.25C9.94036 8.25 10.5 8.80964 10.5 9.5V17C10.5 17.6904 9.94036 18.25 9.25 18.25C8.55964 18.25 8 17.6904 8 17V9.5ZM14.25 8.25C13.5596 8.25 13 8.80964 13 9.5V17C13 17.6904 13.5596 18.25 14.25 18.25C14.9404 18.25 15.5 17.6904 15.5 17V9.5C15.5 8.80964 14.9404 8.25 14.25 8.25Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackDelete);
export default __webpack_public_path__ + "static/media/black-delete.9ec66da9e8c0f994bfd38a9d4ef8c3af.svg";
export { ForwardRef as ReactComponent };